export default __webpack_public_path__ + "static/media/categorySucculent.62275829.jpg";